import { render, staticRenderFns } from "./VxeTableColumnRender.vue?vue&type=template&id=15431be4&"
import script from "./VxeTableColumnRender.vue?vue&type=script&lang=js&"
export * from "./VxeTableColumnRender.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports